import api from './api';

const BASE = '/api/rooms';

export const getRooms = async () => {
  const response = await api.get(BASE);
  return response.data;
};

export const getRoom = async (roomId) => {
  const response = await api.get(`${BASE}/${roomId}`);
  return response.data;
};

export const getRoomStatistics = async (roomId) => {
  const response = await api.get(`${BASE}/${roomId}/statistics`);
  return response.data;
};

export const createRoom = async (data) => {
  const response = await api.post(BASE, data);
  return response.data;
};

export const updateRoom = async (roomId, data) => {
  const response = await api.put(`${BASE}/${roomId}`, data);
  return response.data;
};

export const archiveRoom = async (roomId) => {
  await api.delete(`${BASE}/${roomId}`);
};

export const deleteRoom = archiveRoom;

/** Добавить участника по email. */
export const addMemberByEmail = async (roomId, email) => {
  const response = await api.post(`${BASE}/${roomId}/members`, { email });
  return response.data;
};

/** Добавить в комнату выбранных друзей. */
export const addRoomFriends = async (roomId, friendIds) => {
  const response = await api.post(`${BASE}/${roomId}/members/friends`, { friendIds });
  return response.data;
};

/** Получить список участников комнаты. */
export const getRoomMembers = async (roomId) => {
  const response = await api.get(`${BASE}/${roomId}/members`);
  return response.data;
};

/** Получить суммарную статистику участников комнаты. */
export const getRoomMemberStatistics = async (roomId) => {
  const response = await api.get(`${BASE}/${roomId}/members/statistics`);
  return response.data;
};

/** Изменить роль участника комнаты. */
export const changeRoomMemberRole = async (roomId, userId, role) => {
  const response = await api.patch(`${BASE}/${roomId}/members/${userId}/role`, { role });
  return response.data;
};

/** Удалить участника из комнаты. */
export const removeRoomMember = async (roomId, userId) => {
  await api.delete(`${BASE}/${roomId}/members/${userId}`);
};
